import { axios } from "../api";
import type { ChatApiResponse } from "./types";

export const helpChatApi = {
  async postChat(question: string, sessionId?: string): Promise<ChatApiResponse> {
    const { data } = await axios.post("/v6/chat", {
      question,
      session_id: sessionId,
    });
    return data as ChatApiResponse;
  },
};
